import React from 'react';
import PropTypes from 'prop-types';
import { DialogContext, DispatchDialogContext } from './DialogContext';

const propTypes = {
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
  value: PropTypes.shape({}).isRequired,
};

const DialogProvider = ({ children, dispatch, value }) => (
  <DispatchDialogContext.Provider value={dispatch}>
    <DialogContext.Provider value={value}>
      {children}
    </DialogContext.Provider>
  </DispatchDialogContext.Provider>
);

export default DialogProvider;

DialogProvider.propTypes = propTypes;
